<template>
<div>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-if="aktifmi" persistent max-width="700px" v-model="dialog" @keydown.esc="cancel">
        <v-card>
            <v-card-title style="background-color:#FB9A1E">
                <span class="headline white--text" v-if="iptalTipi == 1" >{{$t('Pnr-Cancellation')}}</span>
                <span class="headline white--text" v-if="iptalTipi == 2" >{{$t('Tracking-Number-Cancellation')}}</span>
            </v-card-title>
            <v-card-text class="pa-4">
                <v-layout wrap>
                    <v-flex v-if="iptalTipi == 2" pr-4>
                        <v-alert :value="true" type="warning">
                            {{ $t('Other-items-cancelled-when-consulate-item-cancelled') }}
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                        <v-form ref="iptaldialog" v-model="valid" lazy-validation>
                            <v-flex xs12 sm12 md12>
                                <v-textarea hide-details rows="5" color="warning" :label="$t('Reason-of-Cancellation')" v-model="iptalMesaj" :rules="[v => !!v || 'İptal Nedeni boş bırakılamaz.']"></v-textarea>
                            </v-flex>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn color="warning" text @click.native="agree">{{ $t('cancel_button') }}  </v-btn>
                <v-btn color="grey" text @click.native="cancel" outline>{{$t('Cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import tool from "@/components/app/coper/tools"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp"

export default {
    props: {
        iptalTipi: {
            type: Number
        },
        iptalNo: {
            type: Number
        },
        aktifmi: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        dialog: false,
        iptalMesaj: null,
        valid: false,
        text1: '',
        snackbar: false,
        }
    },
    beforeMount: beforeMount,
    components: {
        snackbarcomp
    },
    methods: {
        open(value) {
            this.dialog = true
        },
        agree() {
            if (this.$refs.iptaldialog.validate()) {
                this.dialog = false
                let params = {
                    IptalTipi: this.iptalTipi, //PNR iptalinde 1, Takip No iptalinde 2 olacak, Henüz Takip No iptal yapılmadı.
                    IptalNo: this.iptalNo, //PNR No veya Takip No
                    IptalNedeni: this.iptalMesaj
                }
                tool.http_post(this, 'RezervasyonIptal', params).then(
                    response => {
                        if (response.body.Status == true) {
                            this.text1 = "PNR iptal edildi."
                            this.snackbar = true
                            this.dialog = false
                            if(this.iptalTipi == 2){
                            var url1 = '#/coper/rezervasyon/rezervasyonlistesi'
                            window.open(url1, '_self')
                            }else{  
                            location.reload();
                            }
                        } else {
                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                            this.dialog = true
                        }
                    },
                    response => {
                        this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
                        this.snackbar = true
                    }
                );

            }
        },
        cancel() {
            this.dialog = false
        }
    }
}

function beforeMount() {

}
</script>

<style>

</style>
